export class LickertResponse {
    constructor (
        public lickert_question_id : number, // the backend "LickertQuestion" class
        public question_id : number, // the backend "Question" class
        public survey_id : number,
        public response : number
    ){}
}